module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/e51394123b1addd1e694544bda861161.png";